export const PoweredBy = ({ className = '', association = null, white = false }) => (
  <div className={`flex items-center gap-1.5 text-[11px] text-muted-foreground ${className}`} data-testid="powered-by-shariti">
    <span>Powered by</span>
    <span className="font-display font-semibold tracking-wide" style={{ color: white ? '#FFFFFF' : 'var(--shariti-orange)' }}>SHARITI</span>
    {association && <span>· pour {association}</span>}
  </div>
);
